"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useContainer = useContainer;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _context = require("../components/ConfigProvider/context");
var _getPrefixCls = require("../utils/getPrefixCls");
function useContainer() {
  var context = (0, _react.useContext)(_context.ConfigContext);
  var _useState = (0, _react.useState)(document.body),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    container = _useState2[0],
    setContainer = _useState2[1];
  var getContainer = function getContainer() {
    var selector = context.rootId ? "#".concat(context.rootId, " #").concat((0, _getPrefixCls.getPrefixCls)('container')) : "#".concat((0, _getPrefixCls.getPrefixCls)('container'));
    var chatContainer = document.querySelector(selector);
    var containerIsBody = container === document.body;
    if (chatContainer && containerIsBody) {
      setContainer(chatContainer);
    }
  };
  (0, _react.useEffect)(function () {
    getContainer();
  }, []);
  (0, _react.useEffect)(function () {
    context.container && setContainer(context.container);
  }, [context.container]);
  return {
    container: container
  };
}